(function () {
    var menuDrop = {
        $dropdownMenu: document.querySelectorAll('.menu-parent'),
        $pageMain: document.querySelector('main.content'),
        init: function () {
            menuDrop.toggleOverlay();
        },
        toggleOverlay: function () {
            menuDrop.$dropdownMenu.forEach(item => {
                item.addEventListener('mouseenter', function () {
                    menuDrop.$pageMain.classList.add('overlay');
                });
                item.addEventListener('mouseleave', function () {
                    menuDrop.$pageMain.classList.remove('overlay');
                });
            });
        },
    };
    UX.menuDrop = menuDrop;
})();
